export default "__VITE_ASSET__f16bf1f4__"